import t from 'react-translate';
import { useContext } from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { halfSpacing } from 'styles/global_defaults/scaffolding';
import { black, lowTide } from 'styles/global_defaults/colors';
import ClickableContainer from 'components/clickable-container';
import AiConversationContext from './context';
import { config } from '../../../../../config/pendo.config.json';
import { ClosingReason } from './stream-ai-response';

const CompleteStatus = () => {
  const {
    aiRolePlayId,
    handleStartConversation,
  } = useContext(AiConversationContext);
  const aiRolePlay = useSelector((state) => (aiRolePlayId != null ? state.models.aiRolePlays[aiRolePlayId] : null));
  const submission = useSelector((state) => (aiRolePlay?.submissionId ? state.models.aiRolePlaySubmissions[aiRolePlay.submissionId] : null));

  const getStyles = () => {
    switch (submission?.closingReason) {
      case ClosingReason.TERMINATED:
        return css`
          border: 1px solid ${black};
          border-radius: ${halfSpacing}px;
        `;
      case ClosingReason.COMPLETED:
        return css`
          border: 1px solid ${lowTide};
          border-radius: ${halfSpacing}px;
        `;
      default:
        return null;
    }
  };

  switch (submission?.closingReason) {
    case ClosingReason.TERMINATED:
      return (
        <div css={getStyles()} className='d-flex px-4 py-3'>
          <p className='text-regular font-weight-bolder mb-0 text-gray-1'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.ROLE_PLAY_ENDED_DUE_TO_RESPONSE()}</p>
          <ClickableContainer
            className='text-primary ml-1 text-regular font-weight-bold'
            onClick={handleStartConversation}
            data-qa={config.pendo.activities.aiRolePlay.conversationModal.startOver}
          >
            {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.START_OVER()}
          </ClickableContainer>
        </div>
      );
    case ClosingReason.COMPLETED:
      return (
        <div css={getStyles()} className='d-flex py-2 px-4 flex-column'>
          <div>
            <p className='text-regular font-weight-bolder mb-0 text-gray-1'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.FINISHED_ROLE_PLAY()}</p>
          </div>
          <div>
            <p className='text-regular mb-0 text-gray-2'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.LOOK_ON_FEEDBACK()}</p>
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default CompleteStatus;
